import type { TranslationModule } from '../types';

export const ghidTranslations: TranslationModule = {
  ro: {
    seoTitle: "Ghid Interactiv & Labirint de Intenție Juridică — Toate cele 45 de Funcții | Legea Aplicată",
    seoDesc: "Cercetare juridică online, legislație, jurisprudență, pregătire examene (INM, Barou, SNG), cazuri asemănătoare și calculatoare juridice. Navighează inteligent toate funcțiile Legea Aplicată.",
    skipToContent: "Sari la labirintul de intenție și matricea funcțiilor",
    headerBadge: "Funcții · Labirint Decizional",
    headerBadgeTitle: "Arhitectură cognitivă fără LLM — toate funcțiile active",
    personaLensAria: "Lentilă de prioritizare după rolul momentului",
    radarTrigger: "Matricea tuturor funcțiilor",
    classicLink: "Căutare clasică",
    notifications: "Noutăți și notificări",
    langTitle: "LIMBĂ / LANGUAGE",
    themeLight: "Comută pe tema luminoasă",
    themeDark: "Comută pe tema întunecată",

    eyebrow: "LEGEA APLICATĂ · GHID INTERACTIV DE INTENȚIE ȘI ACCES LA TOATE FUNCȚIILE",
    heroTitlePart1: "De la intenția ta la",
    heroTitlePart2: "instrumentul juridic exact.",
    heroSubtitle: "Cercetare juridică online, legislație consolidată, jurisprudență, verificare firme ONRC, pregătire examene (INM, Barou, SNG) și cazuri asemănătoare — ghidate matematic și vizibile integral într-un singur panou de comandă.",
    statActiveFunctions: "funcții active oricând",
    statDomains: "domenii interconectate",
    statPlans: "Planuri:",
    statPlansTier: "Gratuit · Basic · PRO",
    statPlansTooltip: "Vezi planurile Gratuit, Basic și PRO",

    mindreaderAria: "Intuiție matematică a intenției",
    mindreaderIconTitle: "Algoritm determinist 0ms (fără LLM)",
    mindreaderPlaceholder: "Scrie ce ai pe birou: o speță, un nr. de dosar (ex: 1452/299/2026), un CUI, un articol de lege sau ce înveți azi...",
    mindreaderAriaInput: "Descrie ce vrei să faci sau introdu un număr de dosar, CUI, articol ori problemă juridică",
    mindreaderClear: "Șterge textul",
    mindreaderSubmit: "Deschide funcția optimă",
    mindreaderChipsLabel: "Testează detecția matematică (0ms):",
    predictionMatch: "Potrivire matematică",
    predictionLaunchWith: "Lansează {name} cu textul introdus",
    predictionViewLabyrinth: "Vezi în Labirint & conexiuni",
    predictionAltsTitle: "Alte funcții compatibile cu intenția ta:",

    chamberAria: "Labirintul interactiv de intenție",
    trailAria: "Firul Ariadnei — Pașii din labirint",
    step1Label: "Pasul 1:",
    step1Default: "Alege intenția de bază (5 porți)",
    step2Label: "Pasul 2:",
    step2Default: "Rafinează situația concretă",
    step3Label: "Pasul 3:",
    step3Default: "Instrumentul exact + Punte laterală",
    precisionLabel: "Precizie ghidare:",
    recentLabel: "Folosite recent / Acces instant:",
    recentTooltip: "Sari direct la {title}",

    step1Kicker: "PASUL 1 DIN 3 · PORȚILE DE INTENȚIE",
    step1Question: "Care este obiectivul tău principal în acest moment?",
    step1Sub: "Nu te încadra într-o singură categorie fixă: alege ce rezolvi acum, iar mai jos în Matricea Sinaptică vezi cum se aprind funcțiile corespunzătoare.",
    connectedFunctions: "funcții conectate",

    backToPortals: "Înapoi la cele 5 porți",
    step2Kicker: "PASUL 2 DIN 3 · RAFINAREA INTENȚIEI",

    backTo: "Înapoi la {title}",
    backToStart: "Înapoi la începutul labirintului",
    resetTrail: "Resetează traseul",
    optimalToolFound: "✓ Instrumentul optim identificat",
    planLabel: "Plan:",
    whyStartHere: "De ce ți se potrivește acum:",
    planAvailability: "Disponibilitate în cont:",
    quickExamples: "Exemple rapide:",
    openTool: "Deschide {name}",
    viewInMatrix: "Vezi poziția în Matricea tuturor funcțiilor",
    siblingsTitle: "Instrumente alternative pe aceeași ramură de intenție:",
    switchInLabyrinth: "Comută în labirint",
    openDirect: "Deschide direct ↗",

    bridgeAsideEyebrow: "⇄ PUNTE LATERALĂ ÎNTRE INTENȚII",
    bridgeAsideTitle: "Ce poți face în pasul următor sau peste câteva ore?",
    bridgeAsideDesc: "Categoriile juridice se întrepătrund. După {name}, utilizatorii trec frecvent către aceste funcții din alte domenii:",
    asideNoCategoryEyebrow: "◈ GHIDARE FĂRĂ CATEGORII RIGIDE",
    asideNoCategoryTitle: "Un singur cont, toate funcțiile deschise oricând",
    asideNoCategoryDesc: "Un avocat poate căuta acum o situație de fapt în jurisprudență, peste 3 ore poate interoga ONRC despre acționariatul unei firme, iar seara poate repeta o instituție în Elemente de Memorat.",
    asidePlanEyebrow: "⚡ ACCES CONFORM PLANULUI",
    asidePlanTitle: "Cum funcționează planurile?",
    asidePlanDesc: "Orice utilizator poate comuta liber între modulele pentru profesioniști, examene și cetățeni, în limita planului activ:",
    planGratuitDesc: "Calculatoare, coduri, dicționar & mostre",
    planBasicDesc: "Cercetare spețe, dosare, studiu & grile",
    planProDesc: "Analiză acte Word, ONRC, BPI, CRM & rapoarte",

    matrixEyebrow: "PANOU SINAPTIC COMPLET · VIZIBILITATE INTEGRALĂ ASUPRA PLATFORMEI",
    matrixTitle: "Toate cele {count} de funcții disponibile în platformă, grupate pe 6 domenii",
    matrixSubtitle: "Pe măsură ce parcurgi Labirintul de mai sus sau scrii în bara matematică, funcțiile compatibile se aprind automat aici. Poți deschide direct orice funcție cu un singur click sau îi poți verifica nivelul de abonament (Gratuit, Basic, PRO).",
    comparePlans: "Compară planurile de abonament",
    allFunctionsFilter: "Toate funcțiile ({count})",
    filterGratuit: "Gratuit / Demo",
    filterGratuitSub: "Acces gratuit sau demo",
    filterBasic: "Basic",
    filterBasicSub: "Incluse în Basic & PRO",
    filterPro: "PRO",
    filterProSub: "Funcții avansate PRO",
    matrixSearchPlaceholder: "Filtrează rapid în toate funcțiile...",
    functionsCount: "funcții",
    inspectInLabyrinth: "Încarcă {title} în Labirintul interactiv",

    crossoverEyebrow: "INTERSECȚIA CATEGORIILOR ÎN TIMP REAL",
    crossoverTitle: "Cum folosește același utilizator funcții din categorii diferite în aceeași zi",
    crossoverSubtitle: "Alege un scenariu și apasă pe orice moment al zilei pentru a vedea cum comută labirintul între cercetare, registre oficiale, studiu și calcule:",

    codesEyebrow: "TEXTUL LEGII ȘI APLICAREA SA · ACCES DIRECT LA CODURILE ACTUALIZATE",
    codesTitle: "Legislație românească consolidată și baze de jurisprudență",
    codesSubtitle: "Consultă direct codurile fundamentale actualizate la zi, deciziile obligatorii ale Înaltei Curți ({iccj}), {cedo} sau {practica}.",
    iccjLink: "RIL și Hotărâri Prealabile ÎCCJ",
    cedoLink: "jurisprudența și fișele tematice CEDO",
    practicaLink: "repertoriul de practică neunitară",

    videoEyebrow: "CUNOAȘTE LEGEA APLICATĂ",
    videoTitle: "Descoperă tehnologia din spatele platformei",
    videoSub: "O prezentare video a proiectului, a arhitecturii de cercetare și a modului în care facem informația juridică mai accesibilă și mai ușor de verificat.",
    videoFallback: "Browserul tău nu poate reda acest videoclip.",
    videoOpen: "Deschide prezentarea video",
    methodEyebrow: "SURSE, METODĂ ȘI ÎNCREDERE",
    methodTitle: "Surse de verificat. Argumente de evaluat.",
    methodSub: "Materialele juridice trebuie consultate în contextul lor complet. Consultă {sources} și măsurile de {security}.",
    methodSourcesLink: "sursele oficiale de date",
    methodSecurityLink: "securitate și confidențialitate",
    methodStep1Title: "Pornește de la întrebarea sau situația ta",
    methodStep1Desc: "Descrie problema în cuvintele tale, introdu un număr de dosar/CUI sau alege poarta de intenție potrivită din labirint.",
    methodStep2Title: "Compară în context și consultă sursa integrală",
    methodStep2Desc: "Citește textele de lege consolidate în Legislație și motivările integrale din Jurisprudență.",
    methodStep3Title: "Verifică data, forma în vigoare și aplicabilitatea",
    methodStep3Desc: "O asemănare între două cazuri nu garantează aceeași soluție. Pentru o opinie adaptată cauzei tale, consultă un avocat.",

    faqBadge: "ÎNAINTE SĂ ÎNCEPI · ÎNTREBĂRI FRECVENTE",
    faqTitle: "Întrebări frecvente despre funcțiile și planurile Legea Aplicată",
    faqSubtitle: "Cum alegi instrumentul potrivit dintre toate funcțiile, cum verifici sursele și cum funcționează accesul pe abonamente.",

    radarTitleKicker: "RADARUL ECOSISTEMULUI LEGEA APLICATĂ",
    radarTitleMain: "Toate cele {count} de funcții disponibile oricând",
    radarClose: "Închide radarul ✕",
    radarAll: "Toate ({count})",
    radarToLabyrinth: "🎯 În Labirint",
    radarDirectLink: "Deschide direct ↗",

    footerDisclaimer: "Legea Aplicată · Platformă operată de VERDICT LINE S.R.L. · Informațiile asistate necesită verificare în sursele oficiale.",
    navHome: "Acasă",
    navSearch: "Căutare juridică",
    navSimilarCases: "Cazuri asemănătoare",
    navLegislation: "Legislație",
    navExams: "Examene juridice",
    navCalculators: "Calculatoare gratuite",
    navPricing: "Abonamente",
    navDataSources: "Surse de date",
    navSecurity: "Securitate",
    navAbout: "Despre noi",
    navContact: "Contact",
    navTerms: "Termeni",
    navPrivacy: "Confidențialitate",
    navCookies: "Cookie-uri"
  },

  en: {
    seoTitle: "Interactive Guide & Legal Intent Labyrinth — All 45 Functions | Legea Aplicată",
    seoDesc: "Online legal research, consolidated legislation, case law, exam prep (INM, Bar, SNG), similar cases, and legal calculators. Intelligently navigate all Legea Aplicată functions.",
    skipToContent: "Skip to intent labyrinth and function matrix",
    headerBadge: "Functions · Decision Labyrinth",
    headerBadgeTitle: "Deterministic cognitive architecture — all functions active",
    personaLensAria: "Priority lens by current role",
    radarTrigger: "All functions matrix",
    classicLink: "Classic search",
    notifications: "News and notifications",
    langTitle: "LIMBĂ / LANGUAGE",
    themeLight: "Switch to light theme",
    themeDark: "Switch to dark theme",

    eyebrow: "LEGEA APLICATĂ · INTERACTIVE INTENT GUIDE & ACCESS TO ALL FUNCTIONS",
    heroTitlePart1: "From your intent to the",
    heroTitlePart2: "exact legal tool.",
    heroSubtitle: "Online legal research, consolidated statutes, case law, company verification, exam prep (INM, Bar, SNG), and similar cases — mathematically guided and fully visible in a single command panel.",
    statActiveFunctions: "functions active at any time",
    statDomains: "interconnected domains",
    statPlans: "Plans:",
    statPlansTier: "Free · Basic · PRO",
    statPlansTooltip: "View Free, Basic, and PRO plans",

    mindreaderAria: "Mathematical intent intuition",
    mindreaderIconTitle: "Deterministic 0ms engine (no LLM)",
    mindreaderPlaceholder: "Type what is on your desk: a case, docket number (e.g.: 1452/299/2026), tax ID, statute article, or topic...",
    mindreaderAriaInput: "Describe what you want to achieve or enter a docket number, tax ID, statute, or legal problem",
    mindreaderClear: "Clear text",
    mindreaderSubmit: "Open optimal tool",
    mindreaderChipsLabel: "Test mathematical detection (0ms):",
    predictionMatch: "Mathematical match",
    predictionLaunchWith: "Launch {name} with entered text",
    predictionViewLabyrinth: "View in Labyrinth & connections",
    predictionAltsTitle: "Other tools compatible with your intent:",

    chamberAria: "Interactive intent labyrinth",
    trailAria: "Ariadne's Thread — Steps in the labyrinth",
    step1Label: "Step 1:",
    step1Default: "Choose primary intent (5 portals)",
    step2Label: "Step 2:",
    step2Default: "Refine concrete situation",
    step3Label: "Step 3:",
    step3Default: "Exact tool + Lateral bridge",
    precisionLabel: "Guidance precision:",
    recentLabel: "Recently used / Instant access:",
    recentTooltip: "Jump directly to {title}",

    step1Kicker: "STEP 1 OF 3 · INTENT PORTALS",
    step1Question: "What is your main goal right now?",
    step1Sub: "Don't confine yourself to a single rigid category: pick what you need to solve right now, and see compatible tools illuminate below in the Synaptic Matrix.",
    connectedFunctions: "connected tools",

    backToPortals: "Back to the 5 portals",
    step2Kicker: "STEP 2 OF 3 · REFINING INTENT",

    backTo: "Back to {title}",
    backToStart: "Back to the start of the labyrinth",
    resetTrail: "Reset trail",
    optimalToolFound: "✓ Optimal tool identified",
    planLabel: "Plan:",
    whyStartHere: "Why this fits you now:",
    planAvailability: "Account availability:",
    quickExamples: "Quick examples:",
    openTool: "Open {name}",
    viewInMatrix: "View position in full function matrix",
    siblingsTitle: "Alternative tools on the same intent branch:",
    switchInLabyrinth: "Switch in labyrinth",
    openDirect: "Open directly ↗",

    bridgeAsideEyebrow: "⇄ LATERAL SYNAPTIC BRIDGE",
    bridgeAsideTitle: "What can you do in the next step or hours later?",
    bridgeAsideDesc: "Legal categories intersect. After {name}, users frequently move to these functions from other domains:",
    asideNoCategoryEyebrow: "◈ GUIDANCE WITHOUT RIGID BOUNDARIES",
    asideNoCategoryTitle: "One single account, all tools open anytime",
    asideNoCategoryDesc: "A lawyer can research case law in the morning, verify company shareholding in ONRC three hours later, and review legal concepts in Memorization Elements in the evening.",
    asidePlanEyebrow: "⚡ ACCESS BY PLAN TIER",
    asidePlanTitle: "How do plans work?",
    asidePlanDesc: "Any user can switch freely between professional, exam, and citizen modules within their active plan tier:",
    planGratuitDesc: "Calculators, codes, dictionary & samples",
    planBasicDesc: "Case research, dockets, study & quizzes",
    planProDesc: "Word contract analysis, ONRC, BPI, CRM & reports",

    matrixEyebrow: "COMPLETE SYNAPTIC PANEL · FULL PLATFORM VISIBILITY",
    matrixTitle: "All {count} functions available in the platform, grouped in 6 domains",
    matrixSubtitle: "As you navigate the Labyrinth above or type in the math bar, compatible tools illuminate automatically here. Click any tool directly or check its access level (Free, Basic, PRO).",
    comparePlans: "Compare subscription plans",
    allFunctionsFilter: "All functions ({count})",
    filterGratuit: "Free / Demo",
    filterGratuitSub: "Free or demo access",
    filterBasic: "Basic",
    filterBasicSub: "Included in Basic & PRO",
    filterPro: "PRO",
    filterProSub: "Advanced PRO features",
    matrixSearchPlaceholder: "Quickly filter all functions...",
    functionsCount: "functions",
    inspectInLabyrinth: "Load {title} into the interactive Labyrinth",

    crossoverEyebrow: "REAL-TIME CATEGORY INTERSECTION",
    crossoverTitle: "How the same user leverages tools from different domains in a single day",
    crossoverSubtitle: "Select a scenario and click any time of day to see how the labyrinth fluidly switches between research, official registers, study, and calculations:",

    codesEyebrow: "STATUTORY TEXT & APPLICATION · DIRECT ACCESS TO CODES",
    codesTitle: "Consolidated Romanian legislation and case law databases",
    codesSubtitle: "Directly consult up-to-date fundamental codes, mandatory High Court rulings ({iccj}), {cedo}, or {practica}.",
    iccjLink: "High Court Appeals in the Interest of Law & Preliminary Rulings",
    cedoLink: "ECHR jurisprudence and thematic fact sheets",
    practicaLink: "non-unitary judicial practice register",

    videoEyebrow: "DISCOVER LEGEA APLICATĂ",
    videoTitle: "Explore the technology behind the platform",
    videoSub: "A video presentation of the project, research architecture, and how we make legal information more accessible and easy to verify.",
    videoFallback: "Your browser cannot play this video.",
    videoOpen: "Open video presentation",
    methodEyebrow: "SOURCES, METHODOLOGY & TRUST",
    methodTitle: "Sources to verify. Arguments to evaluate.",
    methodSub: "Legal materials must be reviewed in their complete context. Consult {sources} and {security} standards.",
    methodSourcesLink: "official data sources",
    methodSecurityLink: "security and confidentiality measures",
    methodStep1Title: "Start from your question or factual situation",
    methodStep1Desc: "Describe the issue in your own words, enter a docket/tax ID, or pick the fitting intent portal in the labyrinth.",
    methodStep2Title: "Compare in context and review full source materials",
    methodStep2Desc: "Read consolidated statutes in Legislation and full judicial reasonings in Case Law.",
    methodStep3Title: "Verify dates, active version, and legal applicability",
    methodStep3Desc: "A similarity between two cases does not guarantee the same outcome. For advice tailored to your matter, consult an attorney.",

    faqBadge: "BEFORE YOU BEGIN · FREQUENTLY ASKED QUESTIONS",
    faqTitle: "Frequently asked questions about Legea Aplicată features and plans",
    faqSubtitle: "How to pick the right tool among all features, verify sources, and understand subscription access.",

    radarTitleKicker: "LEGEA APLICATĂ ECOSYSTEM RADAR",
    radarTitleMain: "All {count} features available at any time",
    radarClose: "Close radar ✕",
    radarAll: "All ({count})",
    radarToLabyrinth: "🎯 In Labyrinth",
    radarDirectLink: "Open directly ↗",

    footerDisclaimer: "Legea Aplicată · Platform operated by VERDICT LINE S.R.L. · Assisted information requires verification in official sources.",
    navHome: "Home",
    navSearch: "Legal Search",
    navSimilarCases: "Similar Cases",
    navLegislation: "Legislation",
    navExams: "Legal Exams",
    navCalculators: "Free Calculators",
    navPricing: "Subscriptions",
    navDataSources: "Data Sources",
    navSecurity: "Security",
    navAbout: "About Us",
    navContact: "Contact",
    navTerms: "Terms",
    navPrivacy: "Privacy",
    navCookies: "Cookies"
  },

  fr: {
    seoTitle: "Guide interactif & Labyrinthe d'intention juridique — Les 45 fonctions | Legea Aplicată",
    seoDesc: "Recherche juridique en ligne, législation, jurisprudence, préparation aux examens (magistrature, barreau), cas similaires et calculateurs spécialisés. Explorez les 45 fonctions.",
    skipToContent: "Passer au labyrinthe d'intention et à la matrice des fonctions",
    headerBadge: "Fonctions · Labyrinthe Décisionnel",
    headerBadgeTitle: "Architecture cognitive déterministe — toutes fonctions actives",
    personaLensAria: "Filtre de priorité selon le rôle du moment",
    radarTrigger: "Matrice de toutes les fonctions",
    classicLink: "Recherche classique",
    notifications: "Nouveautés et notifications",
    langTitle: "LIMBĂ / LANGUAGE",
    themeLight: "Activer le thème clair",
    themeDark: "Activer le thème sombre",

    eyebrow: "LEGEA APLICATĂ · GUIDE INTERACTIF D'INTENTION & ACCÈS À TOUTES LES FONCTIONS",
    heroTitlePart1: "De votre intention à",
    heroTitlePart2: "l'outil juridique exact.",
    heroSubtitle: "Recherche juridique en ligne, lois consolidées, jurisprudence, vérification des entreprises, préparation aux examens et cas similaires — guidés mathématiquement sur un tableau de bord unique.",
    statActiveFunctions: "fonctions actives à tout moment",
    statDomains: "domaines interconnectés",
    statPlans: "Formules :",
    statPlansTier: "Gratuit · Basic · PRO",
    statPlansTooltip: "Voir les formules Gratuit, Basic et PRO",

    mindreaderAria: "Intuition mathématique de l'intention",
    mindreaderIconTitle: "Moteur déterministe 0ms (sans LLM)",
    mindreaderPlaceholder: "Indiquez votre sujet : un litige, numéro de dossier (ex : 1452/299/2026), CUI/SIREN, article de loi ou révision...",
    mindreaderAriaInput: "Décrivez votre démarche ou saisissez un numéro de dossier, CUI, article ou question juridique",
    mindreaderClear: "Effacer le texte",
    mindreaderSubmit: "Ouvrir l'outil optimal",
    mindreaderChipsLabel: "Tester la détection mathématique (0ms) :",
    predictionMatch: "Correspondance mathématique",
    predictionLaunchWith: "Lancer {name} avec le texte saisi",
    predictionViewLabyrinth: "Voir dans le Labyrinthe & connexions",
    predictionAltsTitle: "Autres outils compatibles avec votre démarche :",

    chamberAria: "Labyrinthe interactif d'intention",
    trailAria: "Fil d'Ariane — Étapes du labyrinthe",
    step1Label: "Étape 1 :",
    step1Default: "Choisir l'intention principale (5 portes)",
    step2Label: "Étape 2 :",
    step2Default: "Préciser la situation concrète",
    step3Label: "Étape 3 :",
    step3Default: "Outil exact + Passerelle latérale",
    precisionLabel: "Précision du guidage :",
    recentLabel: "Utilisés récemment / Accès instantané :",
    recentTooltip: "Aller directement à {title}",

    step1Kicker: "ÉTAPE 1 SUR 3 · LES PORTES D'INTENTION",
    step1Question: "Quel est votre objectif principal en ce moment ?",
    step1Sub: "Ne vous limitez pas à une catégorie rigide : choisissez ce que vous traitez actuellement, et visualisez les fonctions correspondantes s'illuminer dans la Matrice synaptique.",
    connectedFunctions: "fonctions connectées",

    backToPortals: "Retour aux 5 portes",
    step2Kicker: "ÉTAPE 2 SUR 3 · AFFINAGE DE L'INTENTION",

    backTo: "Retour à {title}",
    backToStart: "Retour au début du labyrinthe",
    resetTrail: "Réinitialiser le parcours",
    optimalToolFound: "✓ Outil optimal identifié",
    planLabel: "Formule :",
    whyStartHere: "Pourquoi cet outil vous convient maintenant :",
    planAvailability: "Disponibilité dans le compte :",
    quickExamples: "Exemples rapides :",
    openTool: "Ouvrir {name}",
    viewInMatrix: "Voir l'emplacement dans la Matrice de toutes les fonctions",
    siblingsTitle: "Outils alternatifs sur la même branche d'intention :",
    switchInLabyrinth: "Basculer dans le labyrinthe",
    openDirect: "Ouvrir directement ↗",

    bridgeAsideEyebrow: "⇄ PASSERELLE LATÉRALE ENTRE INTENTIONS",
    bridgeAsideTitle: "Que pouvez-vous faire à l'étape suivante ou quelques heures plus tard ?",
    bridgeAsideDesc: "Les catégories juridiques s'entrecroisent. Après {name}, les utilisateurs passent fréquemment à ces outils issus d'autres domaines :",
    asideNoCategoryEyebrow: "◈ GUIDAGE SANS CATÉGORIES RIGIDES",
    asideNoCategoryTitle: "Un seul compte, tous les outils ouverts à tout moment",
    asideNoCategoryDesc: "Un avocat peut chercher de la jurisprudence le matin, vérifier l'actionnariat d'une société l'après-midi et réviser une notion le soir dans Éléments à mémoriser.",
    asidePlanEyebrow: "⚡ ACCÈS SELON LA FORMULE",
    asidePlanTitle: "Comment fonctionnent les formules ?",
    asidePlanDesc: "Chaque utilisateur bascule librement entre modules professionnels, d'examen et grand public, dans la limite de sa formule active :",
    planGratuitDesc: "Calculateurs, codes, dictionnaire & échantillons",
    planBasicDesc: "Recherche de jurisprudence, dossiers, révisions & QCM",
    planProDesc: "Analyse d'actes Word, ONRC, BPI, CRM & rapports",

    matrixEyebrow: "PANNEAU SYNAPTIQUE COMPLET · VISIBILITÉ INTÉGRALE SUR LA PLATEFORME",
    matrixTitle: "Les {count} fonctions disponibles sur la plateforme, réparties en 6 domaines",
    matrixSubtitle: "À mesure que vous parcourez le Labyrinthe ci-dessus ou saisissez une requête, les modules compatibles s'illuminent automatiquement. Ouvrez directement chaque outil ou vérifiez sa formule d'accès (Gratuit, Basic, PRO).",
    comparePlans: "Comparer les formules d'abonnement",
    allFunctionsFilter: "Toutes les fonctions ({count})",
    filterGratuit: "Gratuit / Démo",
    filterGratuitSub: "Accès gratuit ou démo",
    filterBasic: "Basic",
    filterBasicSub: "Inclus dans Basic & PRO",
    filterPro: "PRO",
    filterProSub: "Fonctionnalités avancées PRO",
    matrixSearchPlaceholder: "Filtrer rapidement dans toutes les fonctions...",
    functionsCount: "fonctions",
    inspectInLabyrinth: "Charger {title} dans le Labyrinthe interactif",

    crossoverEyebrow: "CROISEMENT DES CATÉGORIES EN TEMPS RÉEL",
    crossoverTitle: "Comment un même utilisateur mobilise différents modules au cours d'une même journée",
    crossoverSubtitle: "Choisissez un scénario et cliquez sur un moment de la journée pour voir comment le labyrinthe bascule entre recherche, registres, études et calculs :",

    codesEyebrow: "TEXTE DE LOI & APPLICATION · ACCÈS DIRECT AUX CODES À JOUR",
    codesTitle: "Législation roumaine consolidée et bases de jurisprudence",
    codesSubtitle: "Consultez directement les codes fondamentaux mis à jour, les arrêts obligatoires de la Haute Cour ({iccj}), {cedo} ou {practica}.",
    iccjLink: "RIL et arrêts préalables de la Haute Cour",
    cedoLink: "jurisprudence et fiches thématiques CEDH",
    practicaLink: "répertoire de pratique non uniforme",

    videoEyebrow: "DÉCOUVREZ LEGEA APLICATĂ",
    videoTitle: "Explorez la technologie derrière la plateforme",
    videoSub: "Une présentation vidéo du projet, de l'architecture de recherche et de la façon dont nous rendons l'information juridique accessible et vérifiable.",
    videoFallback: "Votre navigateur ne peut pas lire cette vidéo.",
    videoOpen: "Ouvrir la présentation vidéo",
    methodEyebrow: "SOURCES, MÉTHODE & CONFIANCE",
    methodTitle: "Sources à vérifier. Arguments à évaluer.",
    methodSub: "Les documents juridiques doivent être consultés dans leur contexte complet. Consultez les {sources} et les mesures de {security}.",
    methodSourcesLink: "sources officielles de données",
    methodSecurityLink: "sécurité et confidentialité",
    methodStep1Title: "Partez de votre question ou situation factuelle",
    methodStep1Desc: "Décrivez le problème en vos propres termes, saisissez un numéro de dossier/CUI ou choisissez la porte d'intention correspondante.",
    methodStep2Title: "Comparez dans le contexte et consultez la source intégrale",
    methodStep2Desc: "Lisez les textes de loi consolidés dans Législation et les motivations intégrales dans Jurisprudence.",
    methodStep3Title: "Vérifiez les dates, la version en vigueur et l'applicabilité",
    methodStep3Desc: "Une ressemblance entre deux litiges ne garantit pas la même issue. Pour un avis juridique adapté, consultez un avocat.",

    faqBadge: "AVANT DE COMMENCER · FOIRE AUX QUESTIONS",
    faqTitle: "Foire aux questions sur les fonctionnalités et formules de Legea Aplicată",
    faqSubtitle: "Comment choisir le bon outil parmi les fonctions, vérifier les sources et comprendre les niveaux d'accès.",

    radarTitleKicker: "RADAR DE L'ÉCOSYSTÈME LEGEA APLICATĂ",
    radarTitleMain: "Les {count} fonctions disponibles à tout moment",
    radarClose: "Fermer le radar ✕",
    radarAll: "Toutes ({count})",
    radarToLabyrinth: "🎯 Dans le Labyrinthe",
    radarDirectLink: "Ouvrir directement ↗",

    footerDisclaimer: "Legea Aplicată · Plateforme opérée par VERDICT LINE S.R.L. · Les informations fournies nécessitent vérification dans les sources officielles.",
    navHome: "Accueil",
    navSearch: "Recherche juridique",
    navSimilarCases: "Cas similaires",
    navLegislation: "Législation",
    navExams: "Examens juridiques",
    navCalculators: "Calculateurs gratuits",
    navPricing: "Abonnements",
    navDataSources: "Sources de données",
    navSecurity: "Sécurité",
    navAbout: "À propos",
    navContact: "Contact",
    navTerms: "Conditions",
    navPrivacy: "Confidentialité",
    navCookies: "Cookies"
  }
};

export default ghidTranslations;
